import React, {useState, useEffect} from 'react'
import {withRouter} from "react-router-dom";
import {loadStripe} from "@stripe/stripe-js";
import axios from "axios";
import CustomerLoading from "../components/CustomerLoading";
import StripeInvoiceSummary from "../components/StripeInvoiceSummary";
import {Elements} from "@stripe/react-stripe-js";
import StripePayment from "../components/StripePayment";
import {PageHeader, Skeleton} from 'antd'
import GlobalError from '../components/GlobalError';
import {handleError} from "../common/utils";
import agent from "../api/agent";
import ButtonLoading from "../components/ButtonLoading";

const LeftPanel = ({
  paymentId, 
  setInvoiceUpdate, 
  packageId, 
  setAllowCheckout, 
  setHasCheckoutThrownError, 
  setRightSideLoading
}) => {
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (paymentId) {
      handleRequestAbandon()
    }
  }, [paymentId])

  const handleRequestAbandon = async () => {
    try {
      setRightSideLoading(true); // Optional: Show loading indicator
      setAllowCheckout(false)

      const checkoutInvoiceResp = await agent.checkout.abandonReview({
        packageId,
      })

      const checkoutInvoice = checkoutInvoiceResp.data.data
      const {invoiceId} = checkoutInvoice
      setInvoiceUpdate(checkoutInvoice)

      await agent.checkout.updateStripeCheckout({
        paymentIntentId: paymentId,
        invoiceId: invoiceId,
      })

      setAllowCheckout(true)
    } catch (e) {
      setMessage(e.message);
      handleError(e);
      setAllowCheckout(false);
      setHasCheckoutThrownError(true)
    } finally {
      setRightSideLoading(false); // Optional: Hide loading indicator
    }
  };

  return (
      <div>
        <div className="notice notice-info">
          <div className="notice-content">
            We charge a $5 fee to abandon your package, on top of any storage or other fees attached to your package.
            <br/>Once you checkout, your package will be abandoned permanently. You cannot recover it.
          </div>
        </div>
        {message && <div className="error-text">{message}</div>}
      </div>
  )


}

const googleAddressKey = 'AIzaSyDe7SUUVtVJJ5DHYe-ZuKkBV3Wh-fbV7PY'
const loader = 'auto';

const AbandonStripeCheckout = (props) => {
  const {packageId} = props.match.params
  const [isLoading, setIsLoading] = useState(false)
  const [clientSecret, setClientSecret] = useState('')
  const [paymentId, setPaymentId] = useState('')
  const [customerOptions, setCustomerOptions] = useState({customer: '', ephemeralKey: ''})
  const [invoiceData, setInvoiceData] = useState({})
  const [packageData, setPackageData] = useState({})
  const [invoiceId, setInvoiceId] = useState('')
  const [invoiceUpdate, setInvoiceUpdate] = useState({})
  const [allowCheckout, setAllowCheckout] = useState(false)
  const [hasCheckoutThrownError, setHasCheckoutThrownError] = useState(false)
  const [shippingAddress, setShippingAddress] = useState({})
  const [noPaymentLoading, setNoPaymentLoading] = useState(false)
  const [paypalClientId, setPaypalClientId] = useState('')
  const [stripePromise, setStripePromise] = useState(null)
  const [rightSideLoading, setRightSideLoading] = useState(false)

  useEffect(() => {
    document.body.style.paddingTop = '0';
  }, []);

  const getStripePromise = (stripePublishableKey) => {
    const promise = loadStripe(stripePublishableKey, {apiVersion: '2024-06-20',betas: ['elements_customers_beta_1']})
    setStripePromise(promise)
  }

  const createServicesInvoice = async () => {
    try {
      setIsLoading(true)
      const postData = {
        packageId: packageId,
      }
      const response = await axios.post('/v1/checkout/services', postData)
      const stripePublishableKey = response.data.data.credentials.stripePublishableKey;
      await getStripePromise(stripePublishableKey)
      
      setInvoiceData(response.data.data)
      setInvoiceId(response.data.data.invoiceId)
      setPackageData(response.data.data.package)
      setPaypalClientId(response.data.data.credentials.paypalClientId)
    } catch (e) {
      handleError(e)
    } finally {
      setIsLoading(false)
    }
  }

  const processStripeCheckout = async (invoiceId) => {
    try {
      const requestBody = {
        invoiceId: invoiceId
      }

      const response = await agent.checkout.stripeCheckout(requestBody)
      
      const stripeRes = response.data.data
      console.log('stripe RES:', stripeRes)
      setClientSecret(stripeRes.paymentIntent)
      setPaymentId(stripeRes.paymentIntentId)
      setCustomerOptions({customer: stripeRes.stripeCustomerId, ephemeralKey: stripeRes.ephemeralKey})
    } catch (e) {
      handleError(e)
    }
  }

  const noPaymentCheckout = async () => {
    try {
      setNoPaymentLoading(true)
      const postData = {
        invoiceId: invoiceData.invoiceId,
        packageId: packageId,
      }

      await agent.checkout.noPaymentCheckout(postData)
      props.history.replace('/done/packageAbandon')

    }catch (e) {
      handleError(e)
    }finally {
      setNoPaymentLoading(false)
    }
  }
  
  const goBack = () => {
    props.history.push('/package?pkg=' + packageId)
  }

  const checkoutRequirement = packageData.disposition === 0 && packageData.lockedForProcessing === 0

  useEffect(() => {
    if (packageId) {
      createServicesInvoice()
    }
  }, [packageId])

  useEffect(() => {
    if (invoiceId) {
      processStripeCheckout(invoiceId)
    }
  }, [invoiceId]);

  useEffect( () => {
    if (invoiceUpdate.invoiceId) {
      setInvoiceData(invoiceUpdate)
      setAllowCheckout(true)
    }
    
  }, [invoiceUpdate])

  if (isLoading || !clientSecret || !stripePromise) {
    return (
      <div>
        <CustomerLoading/>
      </div>
    )
  }

  const options = {
    clientSecret,
    loader,
    customerOptions
  }

  if(hasCheckoutThrownError) {
    return (
      <div>
        <GlobalError/>
      </div>
    )
  }

  return (
    <div  className="stripe-checkout">
      <div className="stripe-checkout-banner">
        <PageHeader title={<div>Abandon Package #{packageId?.toString().padStart(6, '0')} </div>} onBack={goBack}/>
      </div>

      <div className="stripe-checkout-container">
        <div className="stripe-checkout-sub-container left-sub-container">
          <div className="stripe-checkout-content">
            {clientSecret && <Elements stripe={stripePromise} options={{clientSecret}}>
          <LeftPanel paymentId={paymentId} setInvoiceUpdate={setInvoiceUpdate} packageId={parseInt(packageId)} setShippingAddress={setShippingAddress} setAllowCheckout={setAllowCheckout} setHasCheckoutThrownError={setHasCheckoutThrownError} setRightSideLoading={setRightSideLoading}/>
          </Elements>}
          </div>
        </div>

        <div className="stripe-checkout-sub-container right-sub-container">
          <div className="content-sticky">
          {!!invoiceData && (
            <StripeInvoiceSummary
              invoiceData={invoiceData}
              setInvoiceUpdate={setInvoiceUpdate}
              paymentIntentId={paymentId}
              allowCheckout={allowCheckout}
            />
          )}
          {rightSideLoading ? (
            <div className="right-side-skeleton">
              <Skeleton active={true} />
            </div>
          ) : (
            <div>
              {allowCheckout && checkoutRequirement && invoiceData.balance > 0 && (
                <div className="stripe-checkout-content">
                  {clientSecret && (
                    <Elements stripe={stripePromise} options={options}>
                      {paypalClientId && (
                        <StripePayment
                          shippingAddress={shippingAddress}
                          googleAddressKey={googleAddressKey}
                          invoiceId={invoiceData.invoiceId}
                          invoiceAmount={invoiceData.balance}
                          packageId={packageId}
                          paypalClientId={paypalClientId}
                          mobile={false}
                          isAbandon={true}
                        />
                      )}
                    </Elements>
                  )}
                </div>
              )}
            </div>
          )}
          {allowCheckout && 
            checkoutRequirement && 
            invoiceData.balance === 0 && (
              <div className="stripe-checkout-content">
                {noPaymentLoading ? (
                  <div className="btn btn-primary srr-button">
                    <ButtonLoading />
                  </div>
                ) : (
                  <button 
                    className="btn btn-primary srr-button" 
                    onClick={noPaymentCheckout}
                  >
                    Ship Package
                  </button>
                )}
              </div>
            )
          }
          </div>
        </div>
      </div>

    </div>
  )
}

export default withRouter(AbandonStripeCheckout)